// Статические картинки из app/frontend/images попадают в сборку только если
// их кто-то импортировал. Забираем всю папку разом — во вью на них ссылается
// image_pack_tag('images/...').
require.context('../images', true, /\.(png|jpe?g|gif|svg|ico|webp|avif)$/);

import Turbolinks from "turbolinks";
Turbolinks.start();

import Rails from "@rails/ujs";
window.Rails = Rails;
if(Rails.fire(document, "rails:attachBindings")) { Rails.start(); }

import '@popperjs/core'

import '@fortawesome/fontawesome-free/css/all.css'

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import '../javascripts/public/serviceworker-companion'
import '../javascripts/public/closeModal'
import '../javascripts/public/popover'
import '../javascripts/public/donate-modal'
import '../javascripts/public/copy-url'
import '../javascripts/public/scroll-top'
import '../javascripts/public/fontSizeModifier'
import '../javascripts/public/yandex-rtb'

import '../stylesheets/public/application.scss';
